var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('sectionHeader'),_c('sectionBanner'),_c('sectionOne'),_c('sectionTwo'),_c('sectionThree'),_c('sectionFour'),_c('sectionFive'),_c('sectionSix'),_c('GameIcon'),_c('sectionSeven'),_c('sectionFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }